<template>
  <div :class="['select-wrap', curItem.key]">
    <el-dropdown trigger="click" @command="changeType">
      <span class="el-dropdown-link">
        <div class="show-text">
          <i v-if="curItem.key === 'ysc'" class="el-icon-check"></i>
          <i v-else-if="curItem.key === 'wsc'" class="el-icon-minus"></i>
          <span v-else>{{ curItem.label }}</span>
        </div>
        <i class="el-icon-caret-bottom"></i>
      </span>
      <el-dropdown-menu class="dropdown-wrap" slot="dropdown">
        <div class="ma-check-wrap">
          <el-dropdown-item :class="['ma-option-wrap', item.key]" v-for="item of optionSelect" :key="item.key" :command="item">
            <i v-if="item.key === 'ysc'" class="el-icon-check"></i>
            <i v-else-if="item.key === 'wsc'" class="el-icon-minus"></i>
          </el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    value: Number,
    saveType: Number,
    effectType: String,
    isCanSetEffect: Boolean,
  },
  name: "CheckSelect",
  data() {
    return {
      curItem: {},
      allSelect: [
        { label: "未上传", key: "wsc", value: 0 },
        { label: "已上传", key: "ysc", value: 1 },
        { label: "有效", key: "yx", value: 2 },
        { label: "有效+", key: "yxpro", value: 3 },
        { label: "带量", key: "dl", value: 4 },
      ],
      optionSelect: [],
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    changeType(item) {
      this.curItem = item;
      this.$emit("input", item.value);
    },
    initData() {
      //初始化数据
      this.curItem = this.allSelect.find((item) => item.value === this.saveType);
      //初始化当前下拉
      this.optionSelect = this.allSelect.filter((item) => {
        if (this.effectType === "materialEffect") {
          return this.isCanSetEffect ? ["yx", "yxpro", "dl"].includes(item.key) : ["wsc"].includes(item.key);
        } else {
          switch (this.saveType) {
            case 0:
              return ["wsc", "ysc"].includes(item.key);
            case 1:
              return ["ysc", "yx", "yxpro", "dl"].includes(item.key);
            case 2:
            case 3:
            case 4:
              return ["yx", "yxpro", "dl"].includes(item.key);
            default:
              return false;
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.select-wrap {
  display: inline-block;
  padding: 0px 6px;
  border-radius: 4px;
  .el-dropdown-link {
    display: flex;
    align-items: center;
    .show-text {
      font-size: 14px;
    }
  }
  &.wsc {
    background-color: rgb(240, 240, 240);
    .show-text {
      font-size: 20px;
    }
  }
  &.ysc {
    background-color: rgba(248, 248, 248, 1);
    .show-text {
      color: rgba(24, 144, 255, 1);
      font-size: 20px;
    }
  }
  &.yx {
    background-color: rgba(255, 237, 141, 1);
    .show-text {
      color: rgba(170, 105, 8, 1);
    }
  }
  &.yxpro {
    background-color: rgba(143, 235, 207, 1);
    color: rgba(12, 131, 95, 1);
  }
  &.dl {
    background-color: rgba(172, 131, 246, 1);
    .show-text {
      color: white;
    }
  }
}
.dropdown-wrap {
  padding: 0px;
  .ma-check-wrap {
    display: block;
    display: flex;
    .ma-option-wrap {
      width: 20px !important;
      height: 20px;
      margin: 4px;
      flex-shrink: 0;
      padding: 0px;
      cursor: pointer;
      &.yx {
        background-color: rgba(255, 237, 141, 1);
      }
      &.yxpro {
        background-color: rgba(143, 235, 207, 1);
      }
      &.dl {
        background-color: rgba(172, 131, 246, 1);
      }
      &.ysc {
        line-height: 20px;
        text-align: center;
        font-size: 18px;
        color: rgba(24, 144, 255, 1);
      }
      &.wsc {
        line-height: 20px;
        text-align: center;
        font-size: 18px;
      }
    }
  }
}
</style>
